import { inject, Inject, Injectable, PLATFORM_ID } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';

@Injectable({
  providedIn: 'root',
})
export class BrowserService {

  private isBrowser: boolean;


  constructor() {
    const platformId = inject(PLATFORM_ID);
    this.isBrowser = isPlatformBrowser(platformId);
  }

    // Check if the current platform is a browser
    isBrowserPlatform(): boolean {
      return this.isBrowser;
    }

    // Access localStorage safely
    localStorageSetItem(key: string, value: string): void {
      if (this.isBrowser) {
        window.localStorage.setItem(key, value);
      }
    }

    localStorageGetItem(key: string): string | null {
      if (this.isBrowser) {
        return window.localStorage.getItem(key);
      }
      return null;
    }

    localStorageRemoveItem(key: string): void {
      if (this.isBrowser) {
        window.localStorage.removeItem(key);
      }
    }

    localStorageClear(): void {
      if (this.isBrowser) {
        window.localStorage.clear();
      }
    }

  get document(): Document | null {
    return this.isBrowser ? document : null;
  }

  matchMedia(query: string): MediaQueryList | null {
    return this.isBrowser && window.matchMedia ? window.matchMedia(query) : null
  }

  get innerWidth(): number | null {
    return this.isBrowser? window.innerWidth : null
  }

  createIntersectionObserver(
    callback: IntersectionObserverCallback,
    options?: IntersectionObserverInit
  ): IntersectionObserver | null {
    if (this.isBrowser && 'IntersectionObserver' in window) {
      return new IntersectionObserver(callback, options);
    } else {
      console.warn('IntersectionObserver is not supported in SSR or this environment.');
      return null;
    }
  }

  // Since heic2any requires access to dom elements, any usage of this library
  // must be checked first to ensure we are in the platform side and not the serverside.
  async convertHeicToAny(file: File, toType: string): Promise<any> {
    if (this.isBrowser) {
      // Dynamically import the library to avoid SSR issues
      const { default: heic2any } = await import('heic2any');
      return heic2any({ blob: file, toType });
    } else {
      throw new Error('heic2any cannot be used on the server.');
    }
  }


}
